'use client';

import { useCallback } from 'react';

import { useQuery, useQueryClient } from '@tanstack/react-query';

import { type User } from '@/domain/User';
import { Repositories } from '@/infra/repositories';

const queryKey = ['user-resources'];

function useUserResources<TData = User>(select?: (data: User) => TData) {
  const queryClient = useQueryClient();

  const updateCartItems = useCallback(
    (count: number) => {
      const currentUser = queryClient.getQueryData<User>(queryKey);

      queryClient.setQueryData(queryKey, {
        ...currentUser,
        cartItems: count,
      });
    },
    [queryClient]
  );

  const query = useQuery({
    queryKey,
    queryFn: Repositories.User.getUserResources,
    staleTime: Infinity,
    select,
  });

  return {
    ...query,
    updateCartItems,
  };
}

export default useUserResources;
